<template>
  <div class="relative rounded-md min-h-72 md:min-h-48 overflow-hidden">
    <strapi-image
      v-if="component.customComponent.backgroundImage"
      class="absolute inset-0 w-full h-full rounded-md object-cover shadow-md"
      :image="component.customComponent.backgroundImage"
      :image-class="'w-full h-full object-cover rounded'"
      :lazy="false"
    />
    <div
      class="relative p-4 md:p-8 flex flex-wrap items-center justify-between"
    >
      <div class="w-full md:flex-1 lg:w-1/2">
        <h2 class="mb-0 uppercase">{{ component.customComponent.title }}</h2>
        <p class="mt-4 tracking-wider">
          <strong>{{ component.customComponent.content }}</strong>
        </p>
        <template v-if="buttons.length > 0">
          <common-button
            v-for="button in buttons"
            :key="button.id"
            :href="button.link"
            :target="button.newTab ? '_blank' : '_self'"
            :rel="button.newTab ? 'noopener noreferrer' : undefined"
            size="sm"
            class="mt-4"
          >
            {{ button.text }}
          </common-button>
        </template>
        <common-button v-else :href="orderUrl" size="sm" class="mt-4">
          {{ t('frontend/order-now') }}
        </common-button>
      </div>
      <div
        class="ml-auto mt-4 md:mt-0 rounded-full size-28 md:size-36 p-2 shadow-md bg-linear-to-br from-depth-3 from-10% to-depth-4 to-80%"
      >
        <div
          class="size-24 md:size-32 rounded-full uppercase text-center border border-mouse flex flex-col items-center justify-center md:tracking-[2.4px]"
        >
          <span class="font-bold text-xl">+ 25GB</span>
          <span class="font-bold">Modspace</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { StrapiCustomComponent } from '~/apollo/types/types';

// TODO: Remove after migrating to generic banner component
const props = defineProps<{
  orderUrl: string;
  component: StrapiCustomComponent;
}>();

const { t } = useI18n();

const buttons = computed(() => props.component.customComponent?.buttons ?? []);
</script>
